var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "favourite-sl",
  "use": "favourite-sl-usage",
  "viewBox": "0 0 35 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 32\" id=\"favourite-sl\"><path d=\"M17.455 0l5.752 10.059 11.702 2.169-8.218 8.382L28.17 32l-10.782-4.931L6.59 32l1.627-11.39-8.218-8.382 11.702-2.17L17.453-.001z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id